import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {CreateAccessFormValidationSchema} from '../../formSchemas'
import {useFormContext, Controller, useWatch} from 'react-hook-form'
import {InputDate} from '@/components/commons/input-date/InputDate'
import {DEFAULT_AVAILABILITY_OPTIONS, InputTime} from '@/components/commons/input-time/InputTime'
import {Switch} from '@/components/commons/switch/Switch'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'
import {AccessFormMissedAccess} from '../access-form-missed-access/AccessFormMissedAccess'
import {AccessesToRecoveryField} from '@/features/agenda/components/agenda-event-form/accesses-to-recover-field/AccessesToRecoverField'
import {DEFAULT_END_TIME, DEFAULT_START_TIME, DEFAULT_TIME_INTERVAL} from '@/features/users-availability/utils'
import {AccessInfoFields} from '@/components/commons/access-info-fields/AccessInfoFields'

export const AccessFormSingleDayFields = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<CreateAccessFormValidationSchema>()
    const patient = useWatch({control, name: 'patient'})
    const consultant = useWatch({control, name: 'consultant'})
    const accessTypeId = useWatch({control, name: 'accessType.id'})
    const isARecovery = useWatch({control, name: 'isARecovery'})
    const accessType = useWatch({control, name: 'accessType.accessType'})
    const project = useWatch({control, name: 'project'})
    return (
        <Grid columns={2} columnGap={4} rowGap={6} fullWidth>
            <Controller
                control={control}
                name="date"
                render={({field, fieldState}) => (
                    <InputDate
                        label={t('commons:date')}
                        value={field.value}
                        errorMessage={fieldState.error?.message}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        fullWidth
                        placeholder={'GG/MM/AAAA'}
                        disabled={!project}
                        disableAfterDate={project?.expirationDate ? new Date(project.expirationDate) : undefined}
                        disableBeforeDate={project?.startDate ? new Date(project.startDate) : undefined}
                    />
                )}
            />

            <Controller
                control={control}
                name="time"
                render={({field, fieldState}) => (
                    <InputTime
                        label={t('agenda:start_time')}
                        value={field.value}
                        errorMessage={fieldState.error?.message}
                        onChange={field.onChange}
                        fullWidth
                        startTime={DEFAULT_START_TIME}
                        endTime={DEFAULT_END_TIME}
                        interval={DEFAULT_TIME_INTERVAL}
                        availableSlots={DEFAULT_AVAILABILITY_OPTIONS}
                        placeholder={t('agenda:select_time')}
                    />
                )}
            />
            <Grid columns={2} columnGap={4} fullWidth>
                <AccessInfoFields />
                <Controller
                    control={control}
                    name="isRemote"
                    render={({field}) => (
                        <Flexbox fullWidth justify="end" align="end">
                            <Switch
                                size="sm"
                                label={t('accesses:remote')}
                                checked={field.value}
                                onChange={field.onChange}
                            />
                        </Flexbox>
                    )}
                />
            </Grid>
            <AccessFormMissedAccess />

            {patient && consultant && accessTypeId && isARecovery && (
                <GridItem spanColumn={2}>
                    <AccessesToRecoveryField patientId={patient.id} accessType={accessType} />
                </GridItem>
            )}
        </Grid>
    )
}
